import { ReactNode } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAppSelector, useAppDispatch } from '../hooks/useAppDispatch';
import { clearToken } from '../store/authSlice';

interface LayoutProps {
  children: ReactNode;
}

const navItems = [
  { path: '/', label: 'Overview' },
  { path: '/tokens', label: 'Push Tokens' },
  { path: '/attempts', label: 'Delivery Attempts' },
  { path: '/apps', label: 'Apps Status' },
  { path: '/billing', label: 'Billing' },
];

export function Layout({ children }: LayoutProps) {
  const location = useLocation();
  const dispatch = useAppDispatch();
  const { isAuthenticated, isDevMode } = useAppSelector((state) => state.auth);

  const handleLogout = () => {
    dispatch(clearToken());
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Dev Mode Banner */}
      {isDevMode && (
        <div className="bg-amber-500 text-amber-900 text-center py-1 text-sm font-medium">
          DEV AUTH MODE - Do not use in production
        </div>
      )}

      {/* Header */}
      <header className="bg-white shadow-sm border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center gap-8">
              <h1 className="text-xl font-semibold text-gray-900">
                LevelUp Central Admin
              </h1>
              <nav className="flex gap-1">
                {navItems.map((item) => (
                  <Link
                    key={item.path}
                    to={item.path}
                    className={`px-3 py-2 rounded-md text-sm font-medium transition-colors ${
                      location.pathname === item.path
                        ? 'bg-gray-100 text-gray-900'
                        : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50'
                    }`}
                  >
                    {item.label}
                  </Link>
                ))}
              </nav>
            </div>
            {isAuthenticated && (
              <button
                onClick={handleLogout}
                className="text-sm text-gray-600 hover:text-gray-900"
              >
                Logout
              </button>
            )}
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {children}
      </main>
    </div>
  );
}
